import React from 'react';

const HookLink = ({
  url = '',
  name = '',
  newtab,
}) => (<a href={url} target={newtab ? '_blank' : '_self'} rel="noreferrer">{name}</a>)

export default HookLink;
